import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Invalid link");
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/customer/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid place-items-center px-6 py-16" data-testid="reset-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center">
          <Logo variant="monogram" className="h-14 w-14 dark:invert" loading="eager" />
        </div>
        <h1 className="mt-10 text-4xl font-serif tracking-tighter text-center">Choose a new password</h1>
        {!token ? (
          <p className="mt-10 text-center opacity-70" data-testid="reset-no-token">
            Missing reset token.{" "}
            <Link to="/account/forgot" className="link-underline">
              Request a new link
            </Link>
            .
          </p>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-4">
            <div>
              <Label className="label-xs">New password</Label>
              <Input
                required
                minLength={8}
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-none mt-2"
                data-testid="reset-password"
              />
            </div>
            <div>
              <Label className="label-xs">Confirm password</Label>
              <Input
                required
                minLength={8}
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="rounded-none mt-2"
                data-testid="reset-confirm"
              />
            </div>
            <Button
              type="submit"
              disabled={busy}
              className="w-full h-12 rounded-none label-xs"
              data-testid="reset-submit"
            >
              {busy ? "Saving…" : "Save Password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
